import React from 'react';
import {injectIntl} from 'react-intl';
import {fillChartOptions} from '../../../utils/analytics';
import FullscreenChart from './FullscreenChart';

const buildWordCloudChartOptions = (config, data, hints, intl) => {
    return fillChartOptions({
        series: data.series.map((s, i) => ({
            type: 'wordcloud',
            name: s.name,
            data: s.values,
        })),
    }, config, data, hints, intl);
};

const builders = {
    wordCloud: buildWordCloudChartOptions,
};

const buildOptions = (config, data, hints, intl) => {
    if (builders[config.chart]) {
        return builders[config.chart](config, data, hints, intl);
    }
    return builders.wordCloud(config, data, hints, intl);
};

const GeneratorEntityExtractionWidget = ({intl, data, params, hints}) => (
    <FullscreenChart hints={hints} options={buildOptions(params, data, hints, intl)} customLabel={`n=${data.count}`} />
);

export default injectIntl(GeneratorEntityExtractionWidget);
